import { useState, useEffect } from "react";
import GenericDeleteConfirmation from "components/modals/GenericDelete";
import { userRoleState } from "atoms/atoms-admin";
import { selectedInstanceState } from "atoms/atoms-content";
import { useRecoilValue, useRecoilState } from "recoil";
import { userRoles } from "services/brm/admin-service";
import { AddButton, DeleteButton, SystemApi } from "features/brm";
import Title from "components/elements/StyledTitle";
import Buttons from "components/elements/TableButtonsDivStyled";
import { TYPE, CRUD_EVENT } from "constants/brm";
import systemModals from "components/modals/Modals";

import ContentLayout from "brm/layout/Content/ContentLayout";

import DataflowTable from "./tables/DataflowTable";
import DataflowAddForm from "./forms/DataflowAddForm";
import Event from "./crudEvent";

function Dataflow() {
  const userRole = useRecoilValue(userRoleState);
  const sysEngineerRole = userRoles.properties[userRoles.SYSTEM_ENGINEER].key;
  const [selectedRows, setSelectedRows] = useState([]);
  const [refresh, setRefresh] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [, setSelectedInstance] = useRecoilState(selectedInstanceState);
  const { mutateAsync: deleteDataFlows } = SystemApi.useDeleteDataFlow();

  const addDataflow = () => {
    setModalIsOpen(true);
  };

  useEffect(() => {
    async function multiDeleteApiCalls() {
      setConfirmDelete(false);
      await Promise.all(selectedRows.map((e) => deleteDataFlows({ dataFlowId: e.id })));
      setDeleteModalIsOpen(false);
      setSelectedInstance({});
    }
    if (confirmDelete) {
      multiDeleteApiCalls();
    }
  }, [confirmDelete, deleteDataFlows, selectedRows, setSelectedInstance]);

  const dataFlowHeader = (
    <Title id="DataFlow_title">
      Dataflows
      <Buttons id="DataFlow_buttons">
        <Event constant={CRUD_EVENT.dataFlow} setRefresh={setRefresh} />
        {userRole && userRole === sysEngineerRole ? (
          <>
            {selectedRows.length > 0 && <DeleteButton onClick={() => setDeleteModalIsOpen(true)} />}
            <AddButton onClick={addDataflow} />
          </>
        ) : (
          <br />
        )}
      </Buttons>
    </Title>
  );

  const dataFlowMain = (
    <>
      {deleteModalIsOpen &&
        systemModals.deleteModal(
          "Dataflow_page",
          deleteModalIsOpen,
          setDeleteModalIsOpen,
          <GenericDeleteConfirmation
            elementName={TYPE.dataflow}
            setDeleteModalIsOpen={setDeleteModalIsOpen}
            selectedRows={selectedRows}
            setRefresh={setRefresh}
            setConfirmDelete={setConfirmDelete}
          />,
          TYPE.dataflow
        )}

      {modalIsOpen &&
        systemModals.addModal(
          "Dataflow_page",
          modalIsOpen,
          setModalIsOpen,
          <DataflowAddForm setModalIsOpen={setModalIsOpen} setRefresh={setRefresh} />,
          TYPE.dataflow
        )}

      <DataflowTable
        setSelectedRows={setSelectedRows}
        selectedRows={selectedRows}
        refresh={refresh}
        setRefresh={setRefresh}
        accessibleRole={sysEngineerRole}
      />
    </>
  );

  return <ContentLayout pageId="Dataflow_page" header={dataFlowHeader} main={dataFlowMain} />;
}

export default Dataflow;
